export default {
  email (state) {
    return state.email
  },
  loadingEmail (state) {
    return state.loadingEmail
  },
  logoProvider (state) {
    return state.logo === '' ? '' : state.logo
  },
  registerUrl (state) {
    return state.registerUrl
  },
  loadingLogo (state) {
    return state.loadingLogo
  }
}



// WEBPACK FOOTER //
// ./src/store/Checkin/getters.js